import { lazyLoadView } from '@router/helpers';
export default [
  {
    path: '/laporan-lingkup-pendidikan',
    name: 'laporan-lingkup-pendidikan',
    component: () => lazyLoadView(import('@views/gtk/laporan/lingkup/Index.vue')),
    meta: {
      title: 'Laporan Lingkup Satuan Pendidikan',
    },
  },
  {
    path: '/laporan-lingkup-pendidikan/:psp_kp_pa_id',
    name: 'detail-laporan-lingkup-pendidikan',
    component: () => lazyLoadView(import('@views/gtk/laporan/lingkup/Detail.vue')),
    meta: {
      title: 'Detail Laporan Lingkup Satuan Pendidikan',
    },
  },
  {
    path: '/laporan-pmo-sekolah',
    name: 'laporan-pmo-sekolah',
    component: () => lazyLoadView(import('@views/gtk/laporan/pmo/Index.vue')),
    meta: {
      title: 'Laporan PMO Sekolah',
    },
  },
];
